import React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#ed6c02',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
    },
}));

const DisplayTypeCompanentFOneMoby = (props) => {
    
    const [checked, setChecked] = React.useState(props.checked);


    const handleToggle = (value, code) => () => {

        if (checked.hasOwnProperty(code)) {

            let currentIndex = checked[code].indexOf(String(value));
            if (currentIndex === -1) {
                checked[code].push(String(value));
            } else {
                checked[code].splice(currentIndex, 1);
            }


        }
        else {
            if (code != "")
                checked[code] = [String(value)];
        }


        setChecked(checked);
        props.setCheckenFiltr(checked);
        props.submitForm();
    };

    const labelId = `checkbox-list-label-${props.idOne}`;
    return (
        <ListItemButton role={undefined} onClick={handleToggle(String(props.idOne), props.codeOne)} dense>
            <ListItemIcon>
                {/* <Checkbox
                    edge="start"
                    checked={checked[props.codeOne] ? checked[props.codeOne].indexOf(String(props.idOne)) !== -1 : false}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                /> */}
                                <AntSwitch
                    checked={checked[props.codeOne] ? checked[props.codeOne].indexOf(String(props.idOne)) !== -1 : false}
                    color="warning"
                    inputProps={{ 'aria-label': 'ant design' }}

                />
            </ListItemIcon>
            <ListItemText id={labelId} sx={{ mr: 1, color: "#686868", fontWeight: 700, wordBreak: "break-all" }} primary={`${props.nameValeuOne}`} />
        </ListItemButton>
    )
}

export default DisplayTypeCompanentFOneMoby;